import React from "react";
import api from "../../../Api/apiAxios";

function formatDataCancelamentoBr(dataCancelamento) {
  if (!dataCancelamento) return "* * * * * *";
  try {
    const s = dataCancelamento.toString();

    return `${s.substring(8, 10)}/${s.substring(5, 7)}/${s.substring(0, 4)}`;
  } catch {
    return "* * * * * *";
  }
}

export function useContratoAtual({ numeroSerie, clienteId, pedidoId, sistema }) {
  const [loadingContrato, setLoadingContrato] = React.useState(false);
  const [contrato, setContrato] = React.useState(null);
  const [contratoId, setContratoId] = React.useState(null);
  const [dataCancelamentoContrato, setDataCancelamentoContrato] = React.useState("* * * * * *");

  async function fetchContrato({ numeroSerie, clienteId, pedidoId, sistema }) {
    const params = new URLSearchParams();
    params.set("numeroSerie", numeroSerie);
    if (clienteId) params.set("clienteId", clienteId);
    if (pedidoId && Number(pedidoId) > 0) params.set("pedidoId", pedidoId);
    params.set("sistema", sistema);

    const resp = await api.get(`/Contrato/pedido?${params.toString()}`);
    return Array.isArray(resp.data) && resp.data.length > 0 ? resp.data[0] : null;
  }

  async function fetchContratoPorNumeroSerie(numeroSerie) {
    const resp = await api.get(`/Contrato/retornar-situacao-contrato?numeroSerie=${numeroSerie}`);
    return resp?.data && resp.data.id && resp.data.id > 0 ? resp.data : null;
  }

  React.useEffect(() => {
    (async () => {
      if (!numeroSerie || !sistema) {
        setContrato(null);
        setContratoId(null);
        setDataCancelamentoContrato("* * * * * *");
        return;
      }

      setLoadingContrato(true);
      try {
        let contratoAtual = await fetchContrato({ numeroSerie, clienteId, pedidoId, sistema });

        if (!contratoAtual && pedidoId && Number(pedidoId) > 0) {
          contratoAtual = await fetchContrato({ numeroSerie, clienteId, pedidoId: null, sistema });
        }

        if (!contratoAtual && clienteId) {
          contratoAtual = await fetchContrato({ numeroSerie, clienteId: null, pedidoId: null, sistema });
        }

        if (!contratoAtual) {
          try {
            contratoAtual = await fetchContratoPorNumeroSerie(numeroSerie);
          } catch (e) {
          }
        }

        setContrato(contratoAtual);
        setContratoId(contratoAtual?.id ?? null);
        setDataCancelamentoContrato(formatDataCancelamentoBr(contratoAtual?.dataCancelamento));
      } catch (e) {
        console.error("Erro ao buscar contrato atual:", e);
        setContrato(null);
        setContratoId(null);
        setDataCancelamentoContrato("* * * * * *");
      } finally {
        setLoadingContrato(false);
      }
    })();
  }, [numeroSerie, clienteId, pedidoId, sistema]);

  return { loadingContrato, contrato, contratoId, dataCancelamentoContrato };
}

